import React, { useState, useEffect } from "react";
import L from "leaflet";
import {
    MapContainer,
    TileLayer,
    useMapEvents,
    Marker,
    Popup,
    useMap,
    GeoJSON
} from "react-leaflet";
import "leaflet/dist/leaflet.css";
import { FaCircleCheck, FaHourglassHalf } from "react-icons/fa6";
import { FaTimesCircle } from 'react-icons/fa';
import { TbTargetArrow } from "react-icons/tb";
import axiosInstance from "../../../../Hooks/axoisInstance";
import { API_BASE_URL1 } from "../../../Services/baseApiUrl";
import Select, { CreatableSelect } from '@atlaskit/select';
import GHMCBoundariesJSON from "../../../Common/Json/GHMCBoundaries.json"
import { useNavigate } from "react-router-dom";
import { GVPMapViewCountReport, GVPMapViewReport, GVPGeoJSONZoneWise, GVPGeoJSONCircleWise } from "../../../Apis/GVPMapViewAPI";
import { Icon } from 'leaflet';
import { MarkerF } from "@react-google-maps/api";
import { TableLoader } from "../../../Common/ShimmerLoader";


function GeoJSONLayer({ data }) {
    const map = useMap();
  
    useEffect(() => {
      if (!data) return;
  
      const layer = L.geoJSON(data).addTo(map);
  
      // Clean up previous layer on update
      return () => {
        map.removeLayer(layer);
      };
    }, [data, map]);
  
    return null;
  }

function GVPClearanceMapView() {

    const boundaryStyle = {
        color: 'green', // Boundary line color
        weight: 2,     // Line thickness
        fillColor: 'lightblue', // Polygon fill color
        fillOpacity: 0.4        // Fill opacity
    };
    const [dataLoading, setDataLoading] = useState(true);
    const ClearanceReportDate = localStorage.getItem("ClearanceReportDate");
    const ClearanceReportZone = localStorage.getItem("ClearanceReportZone");
    const ClearanceReportShift = localStorage.getItem("ClearanceReportShift");
    const navigate = useNavigate();
    const [zones, setZones] = useState([]);
    const [filteredRows, setFilteredRows] = useState([]);
    const [circles, setCircles] = useState([]);
    const [selectedGeoJSON, setSelectedGeoJSON] = useState(null);
    const [selectedCircle, setSelectedCircle] = useState("");
    const [loadingCircles, setLoadingCircles] = useState(false);
    const [position, setPosition] = useState({ lat: 17.385044, lng: 78.486671 });
    const [collectionPoints, setCollectionPoints] = useState([]);
    const [collectionPointsValues, setCollectionPointsValues] = useState([]);
    const [selectedCollectionPoints, setSelectedCollectionPoints] = useState([]);
    const [circleFetchError, setCircleFetchError] = useState(null);
    const [optionsMapView, setOptionMapView] = useState([]);
    const [defaultOptionsMapView, setDefaultOptionsMapView] = useState([]);
    const [optsVehicle, setOptsMapView] = useState(optionsMapView);
    const [reportData, setReportData] = useState({});
    const [formInput, setFormInput] = useState({
        Date: ClearanceReportDate || getCurrentDateTime(),
        zoneId: ClearanceReportZone || "",
        circleId: "",
        shiftId: ClearanceReportShift,
        selectedCollectionPoints: [],
        shiftOngoing: "",
    });
    const fetchZoneData = async () => {
        try {
            const response = await GVPGeoJSONZoneWise();
            setZones(response);
        } catch (error) {
            console.error("Error fetching zones:", error);
        }
    };

    useEffect(() => {
        setFormInput((prev) => ({
            ...prev,
            Date: getCurrentDateTime()
        }));
    }, []);

    useEffect(() => {
        const currentShift = getCurrentShift();
        console.log(currentShift, "currentShift")
        setFormInput((prev) => ({ ...prev, shiftId: ClearanceReportShift || currentShift.shiftId, shiftOngoing: currentShift.ongoing }));
        localStorage.setItem("ClearanceReportShift", currentShift.shiftId || ClearanceReportShift);
    }, []);
    
    useEffect(() => {
        fetchZoneData()
        // fetchCirclesData();
        SearchMapView()
    }, []);

    useEffect(() => {
        // Fetching collection point types from the API
        const fetchCollectionPointTypes = async () => {
            try {
                const response = await axiosInstance.get(API_BASE_URL1 + `MasterDetails/GetAllCollectionPointType`);

                setCollectionPointsValues(response.data);
            } catch (error) {
                console.error('Error fetching collection point types:', error);
            }
        };

        fetchCollectionPointTypes();
    }, []);

    const handleMultiSelectChange = (newValue) => {
        if (newValue) {
            // Map the selected options to just their value (IDs)
            setSelectedCollectionPoints(newValue.map(item => item.value));

        } else {
            setSelectedCollectionPoints([]); // Clear when no selection
        }
    };

    const SearchMapView = async () => {
        setDataLoading(true);
        try {
            setDataLoading(true);
            const requestData = {
                Date: formInput.Date,
                ZoneId: formInput.zoneId || '',
                CircleId: formInput.circleId || '',
                ShiftId: formInput.shiftId,
                CollectionPointTypeIds: selectedCollectionPoints.join(",") || '1',
                //CollectionPointTypeIds:1
            };
            const response = await GVPMapViewCountReport(requestData)
            const data = response;
            setCollectionPoints(response.data);
            // setReportData(response.data)
            setReportData({
                totalCollectionPoints: data.totalCollectionPoints,
                clearedCount: data.clearedCount,
                pendingCount: data.pendingCount,
                clearedPercentage: data.clearedPercentage,
                pendingPercentage: data.pendingPercentage,
                collectionPointTypes: data.collectionPointTypes || [],
            });
        } catch (error) {
            console.error('Error fetching data:', error);
            setDataLoading(false);
        } finally {
            setDataLoading(false);
        }
        const currentShift = getCurrentShift();
        setFormInput((prev) => ({ ...prev, shiftOngoing: currentShift.ongoing }));
    };


    useEffect(() => {
        setOptionMapView(collectionPointsValues.map(PointValues => ({
            value: PointValues.collectionPointTypeId,
            label: PointValues.collectionPointTypeName,
        })));
    }, [collectionPointsValues]);


    useEffect(() => {
        // Ensure that formInput.zoneId and zones are available before proceeding
        if (formInput.zoneId && zones.length > 0) {
            // Ensure zoneId is treated as a string for comparison
            const selectedZone = zones.find(zone => String(zone.zoneId) === String(formInput.zoneId));
            console.log(selectedZone, "selectedZone")
            if (selectedZone && selectedZone.geoJson) {
                try {
                    const geoJson = JSON.parse(selectedZone.geoJson); // Parse GeoJSON string to object
                    setTimeout(() => {
                        setSelectedGeoJSON(geoJson)
                      }, 500); // Update GeoJSON state for the map display
                } catch (error) {
                    console.error("Error parsing GeoJSON:", error); // Catch and log any JSON parsing errors
                }
            } else {
                console.log("GeoJSON is missing or invalid for this zone.");
            }
        } else {
            console.log("Zone ID or zones data is not available.");
        }
    }, [formInput.zoneId, zones]); // Re-run the effect when zoneId or zones data changes



    const fetchCirclesData = async (zoneId) => {
        try {
            setLoadingCircles(true);
            const response = await GVPGeoJSONCircleWise(zoneId);
            setCircles(response);
            setLoadingCircles(false);
            setCircleFetchError(null); // Clear error if successful
        } catch (error) {
            console.error("Error fetching circles data:", error);
            setCircles([]); // Clear circles data on error
            setLoadingCircles(false);
            //   setCircleFetchError(
            //     error.response ? error.response.data.message : "Unknown error occurred"
            //   ); // Set error message from the backend or use a default message
            //   toast.error(`Error fetching circles: ${circleFetchError}`);
        }
    };


    const cardConfig = {
        totalCollectionPoints: {
            title: "Total Collection Points",
            icon: <TbTargetArrow className="text-primary" />,
            value: reportData.totalCollectionPoints,
            onClick: null,
            percentage: null
        },
        clearedCount: {
            title: "Cleared",
            icon: <FaCircleCheck className="text-success" />,
            value: reportData.clearedCount,
            onClick: () => handleTargetCount(1),
            percentage: reportData.clearedPercentage ? `${reportData.clearedPercentage}%` : "0%"
        },
        pendingCount: formInput.shiftOngoing
            ? {
                title: "Pending",
                icon: <FaHourglassHalf className="text-warning" />,
                value: reportData.pendingCount < 0 ? 0 : reportData.pendingCount,
                onClick: () => handlePendingReports(1, true),
                percentage: reportData.pendingPercentage ? `${reportData.pendingPercentage}%` : "0%",
            }
            : null,
        notClearedCount: !formInput.shiftOngoing
            ? {
                title: "Not Cleared",
                icon: <FaTimesCircle className="text-danger" />,
                value: reportData.pendingCount < 0 ? 0 : reportData.pendingCount,
                onClick: () => handlePendingReports(1, false),
                percentage: reportData.pendingPercentage ? `${reportData.pendingPercentage}%` : "0%",
            }
            : null,
    };

    const handleCircleChange = (circleId) => {
        const selectedCircle = circles.find(circle => circle.circleId === parseInt(circleId));

        setFormInput(prev => ({ ...prev, circleId }));

        if (selectedCircle && selectedCircle.geoJson) {
            try {
                // Attempt to parse the GeoJSON string
                const geoJson = JSON.parse(selectedCircle.geoJson);
                console.log("Selected GeoJSON:", geoJson);
                setTimeout(() => {
                    setSelectedGeoJSON(geoJson)
                  }, 500);
            } catch (error) {
                // If JSON parsing fails, log the error and handle the invalid GeoJSON
                console.error("Error parsing GeoJSON:", error);
                setSelectedGeoJSON(null);  // Optionally set geoJSON to null if invalid
            }
        } else {
            console.log("GeoJSON is missing or empty for this circle.");
            setSelectedGeoJSON(null);  // Set geoJSON state to null if it's missing or empty
        }
    };


    const handleZoneChange = (zoneId) => {
        const selectedZone = zones.find(zone => zone.zoneId === parseInt(zoneId));
        // console.log(selectedZone, "selectedZone")
        if (selectedZone) {
            const geoJson = (selectedZone?.geoJson); // Parse GeoJSON string to object
            setTimeout(() => {
                setSelectedGeoJSON(geoJson)
            }, 1000);
        }
        setFormInput((prev) => ({
            ...prev,
            zoneId: zoneId, // Update zoneId in formInput
            circleId: "",
        }));
        if (zoneId) {
            fetchCirclesData(zoneId); // Fetch circles data for the selected zone
        } else {
            // If no zone is selected, clear circles dropdown
            setCircles([]);
        }
        localStorage.setItem("ClearanceReportZone", zoneId);
    };


    const handleCreateOption = (inputValue) => {
        if (inputValue) {
            const newValue = { label: inputValue, value: inputValue.toLowerCase() };
            setOptsMapView((prevOptions) => [...prevOptions, newValue]);
            if (typeof setSelectedCollectionPoints === 'function') {
                setSelectedCollectionPoints(newValue.value);
            } else {
                console.error('SelectedCollectionPoints is not a function');
            }
        }
    };

    const handleTargetCount = async (typeId) => {
        setDataLoading(true);
        const queryParams = new URLSearchParams({
            Date: ClearanceReportDate || formInput.Date,
            ZoneId: formInput.zoneId || '',
            CircleId: formInput.circleId || '',
            ShiftId: formInput.shiftId || '',
            CollectionPointTypeIds: typeId,
            TypeId: typeId
        }).toString();

        try {
            const response = await axiosInstance.get(
                API_BASE_URL1 + `CollectionPointReport/GvpTypeBasedMapViewPointsReports?${queryParams}`,
                { headers: { 'Content-Type': 'application/json' } }
            );
            navigate("/gvp-clearance-view-report", { state: { response: response.data, typeId } });
        } catch (error) {
            console.error("Error fetching report:", error);
            setDataLoading(false);
        } finally {
            setDataLoading(false);
        }
    };
    const handlePendingReports = async (CollectionPointTypeIds, isPending) => {
        setDataLoading(true);
        const queryParams = new URLSearchParams({
            Date: ClearanceReportDate || formInput.Date,
            ZoneId: formInput.zoneId || '',
            CircleId: formInput.circleId || '',
            ShiftId: formInput.shiftId || '',
            CollectionPointTypeIds: CollectionPointTypeIds
        }).toString();

        try {
            const response = await axiosInstance.get(
                API_BASE_URL1 + `CollectionPointReport/GVpPendingMapViewPointsResult?${queryParams}`,
                { headers: { 'Content-Type': 'application/json' } }
            );
            navigate("/gvp-clearance-pending-report", { state: { response: response.data, isPending: isPending } });
        } catch (error) {
            console.error("Error fetching report:", error);
            setDataLoading(false);
        } finally {
            setDataLoading(false);
        }
    };

    const handleHotspotCollectionPointCount = async (CollectionPointTypeIds, collectionPointTypeName) => {
        setDataLoading(true);
        const selectedDate = formInput.Date;
        const combinedDate = new Date(selectedDate);
        const currentTime = new Date();
        //  alert(CollectionPointTypeIds)

        // Set the combinedDate to include current time
        combinedDate.setHours(currentTime.getHours());
        combinedDate.setMinutes(currentTime.getMinutes());
        combinedDate.setSeconds(currentTime.getSeconds());

        const queryParams = new URLSearchParams({
            Date: ClearanceReportDate || formInput.Date,
            ZoneId: formInput.zoneId || '',
            CircleId: formInput.circleId || '',
            ShiftId: formInput.shiftId || '',
            CollectionPointTypeIds: CollectionPointTypeIds,
            TypeId: CollectionPointTypeIds
        }).toString();

        try {
            const response = await axiosInstance.get(
                API_BASE_URL1 + `CollectionPointReport/GvpHotspotMapViewPointsResult?${queryParams}`,
                { headers: { 'Content-Type': 'application/json' } }
            );
            navigate("/gvp-hotspot-clearance-report", { state: { response: response.data, collectionPointTypeName }});
        } catch (error) {
            console.error("Error fetching report:", error);
            setDataLoading(false);
        } finally {
            setDataLoading(false);
        }
    };

    const handleTypeBasedCollectionPointCount = async (CollectionPointTypeIds) => {
        setDataLoading(true);
        const selectedDate = formInput.Date;
        const combinedDate = new Date(selectedDate);
        const currentTime = new Date();
        //  alert(CollectionPointTypeIds)

        // Set the combinedDate to include current time
        combinedDate.setHours(currentTime.getHours());
        combinedDate.setMinutes(currentTime.getMinutes());
        combinedDate.setSeconds(currentTime.getSeconds());

        const queryParams = new URLSearchParams({
            Date: ClearanceReportDate || formInput.Date,
            ZoneId: formInput.zoneId || '',
            CircleId: formInput.circleId || '',
            ShiftId: formInput.shiftId || '',
            CollectionPointTypeIds: CollectionPointTypeIds,
            TypeId: 1
        }).toString();

        try {
            const response = await axiosInstance.get(
                API_BASE_URL1 + `CollectionPointReport/GvpTypeBasedMapViewPointsReports?${queryParams}`,
                { headers: { 'Content-Type': 'application/json' } }
            );
            navigate("/gvp-collection-report", { state: { response: response.data, CollectionPointTypeIds } });
        } catch (error) {
            console.error("Error fetching report:", error);
            setDataLoading(false);
        } finally {
            setDataLoading(false);
        }

    };

    const getIconForCollectionPoint = (type) => {
        switch (type) {
            case "GVP":
                return new L.icon({
                    iconUrl: "../../../assets/images/locationgreen.svg",
                    iconSize: [32, 32],
                });
            case "Sweeping Point":
                return new L.icon({
                    iconUrl: "../../../assets/images/locationred.svg",
                    iconSize: [32, 32],

                });
            case "Hotspot":
                return new L.icon({
                    iconUrl: "../../../assets/images/locationyellow.svg",
                    iconSize: [32, 32],

                });
            case "Litter Bin":
                return new L.icon({
                    iconUrl: "../../../assets/images/locationBlue.jpg",
                    iconSize: [32, 32],

                });
            default:
                return new L.icon({
                    iconUrl: "../../../assets/images/locationred.svg",
                    iconSize: [32, 32],
                });

        }
    };

    const getCurrentShift = () => {
        const currentTime = new Date();
        const day = currentTime.getDate();
        const hours = currentTime.getHours();
        const minutes = currentTime.getMinutes();
        const totalMinutes = hours * 60 + minutes;
        const [selectedYear, selectedMonth, selectedDay] = ClearanceReportDate?.split("-") || formInput.Date.split("-");
        // console.log(selectedDay, day, ClearanceReportDate ,"selectedDay - day")
        const isToday = selectedDay == day

        // Define shift timings in minutes since midnight
        const morningStart = 5 * 60;
        const morningEnd = 14 * 90;
        const afternoonStart = 14 * 90;
        const afternoonEnd = 21 * 60;
        const nightStart = 21 * 60;
        const nightEnd = 5 * 60;

        // Determine current shift and if it's ongoing
        if (totalMinutes >= morningStart && totalMinutes < morningEnd && isToday) {
            return { shiftId: "1", ongoing: true }; // Morning shift
        } else if (totalMinutes >= afternoonStart && totalMinutes < afternoonEnd && isToday) {
            return { shiftId: "2", ongoing: true }; // Afternoon shift
        } else if (totalMinutes >= nightStart && totalMinutes < nightEnd && isToday) {
            return { shiftId: "3", ongoing: totalMinutes < nightEnd }; // Night shift
        } else {
            return { shiftId: formInput.shiftId, ongoing: false };
        }
    };




    return (
        <>
            <div style={{ width: "100%" }}>
                <div className="content">
                    <div className="page-content">
                        <div className="row align-items-center my-2">
                            <div className="col-md-6">
                                <h4 class="text-start mb-3">GVP Map View</h4>
                            </div>
                            <div className="col-md-6 text-end">
                                <button className="btn btn-secondary m-0"
                                    onClick={() => navigate(-1)}
                                >
                                    Back
                                </button>
                            </div>
                        </div>
                        <div className="card">
                            <div className="card-body p-3">
                                <div className="row align-items-end" >
                                    <div class="col-md-3 mb-3 text-left">
                                        <label htmlFor="Date">Date:</label>
                                        <input
                                            type="date"
                                            name="date"
                                            value={ClearanceReportDate || formInput.Date}
                                            style={inputStyle}
                                            className="form-control"
                                            max={getCurrentDateTime()} // Set the max attribute to the current date
                                            onChange={(e) => {
                                                setFormInput({
                                                    ...formInput,
                                                    Date: e.target.value,
                                                })
                                                localStorage.setItem(
                                                    "ClearanceReportDate",
                                                    e.target.value
                                                );
                                            }}
                                        />
                                    </div>
                                    <div className="col-md-3 mb-3 text-left">
                                        <label htmlFor="Zone">Zone</label>
                                        <select
                                            className="form-select"
                                            name="zoneId"
                                            value={ClearanceReportZone || formInput.zoneId || ""}
                                            onChange={(e) => handleZoneChange(e.target.value)}
                                        >
                                            <option value="">
                                                All Zones
                                            </option>
                                            {zones?.map((zone) => (
                                                <option key={zone.zoneId} value={zone.zoneId}>
                                                    {zone.zoneName}
                                                </option>
                                            ))}
                                        </select>
                                    </div>
                                    <div className="col-md-3 mb-3 text-left">
                                        <label htmlFor="Circle">Circle</label>
                                        <select
                                            className="form-select"
                                            value={formInput.circleId || ""}
                                            onChange={(e) => {
                                                setFormInput((prevData) => ({
                                                    ...prevData,
                                                    circleId: e.target.value,
                                                }));
                                                handleCircleChange(e.target.value);
                                            }}
                                        >
                                            <option value="" >
                                                All Circle
                                            </option>
                                            {circles.map((circle) => (
                                                <option key={circle.circleId} value={circle.circleId}>
                                                    {circle.circleName}
                                                </option>
                                            ))}
                                        </select>
                                    </div>
                                    <div className="col-md-3 mb-3 text-left">
                                        <label className="form-label">Shift</label>
                                        <select
                                            value={formInput.shiftId}
                                            name="shiftName"
                                            id="shiftName"
                                            className="form-select"
                                            onChange={(e) => {
                                                setFormInput((prevData) => ({
                                                    ...prevData,
                                                    shiftId: e.target.value,
                                                }));
                                                localStorage.setItem("ClearanceReportShift", e.target.value);
                                            }}
                                        >
                                            <option value="1">Morning</option>
                                            <option value="2">Afternoon</option>
                                            <option value="3">Night</option>
                                        </select>
                                    </div>
                                    <div className="col-md-6 mb-3 text-left">
                                        <label className="form-label">Collection Points</label>
                                        <Select
                                            classNamePrefix="CreatableSelect"
                                            onChange={handleMultiSelectChange}
                                            options={optionsMapView}
                                            inputId="collectionPointTypeId"
                                            isClearable={true}
                                            isMulti={true}
                                            name="collectionPointTypeId"
                                            id="collectionPointTypeName"
                                            placeholder="Select"
                                            onCreateOption={handleCreateOption}
                                            value={optionsMapView.filter(option =>
                                                selectedCollectionPoints.includes(option.value)  // Filter selected values to set properly
                                            )}
                                        />
                                    </div>
                                    <div className="col-md-3 mb-3 text-left mt-4">
                                        <button className="btn brown-btn" onClick={SearchMapView}>Search</button>
                                    </div>
                                </div>
                                <div>
                                </div>
                                {/* {Object.keys(reportData).map((key) => ( */}
                                <div className="row mt-4 align-items-center">
                                    {Object.keys(cardConfig)
                                        .filter((key) => cardConfig[key] !== null) // Filter out null entries
                                        .map((key) => (
                                            <div key={key} className="col-12 col-sm-6 col-md-3 mb-3">
                                                <div className="card">
                                                    <div className="card-header bg-light-red">
                                                        <div className="d-flex justify-content-between align-items-center">
                                                            <div className="card-title">{cardConfig[key].title}</div>
                                                            <div className="card-icon">{cardConfig[key].icon}</div>
                                                        </div>
                                                    </div>
                                                    <div className="card-body rounded-0 rounded-bottom border">
                                                        <div className="d-flex justify-content-between">
                                                            <div
                                                                className="card-text"
                                                                style={{ color: cardConfig[key].onClick ? "blue" : "black", cursor: cardConfig[key].onClick ? "pointer" : "default" }}
                                                                onClick={cardConfig[key].onClick}
                                                            >
                                                                {cardConfig[key].value}
                                                            </div>
                                                            {cardConfig[key].percentage && (
                                                                <div className="card-text">{cardConfig[key].percentage}</div>
                                                            )}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        ))}
                                    {(reportData.collectionPointTypes || []).map((type) => (
                                        <div className="col-12 col-sm-6 col-md-3 mb-3" key={type.collectionPointTypeId}>
                                            <div className="card">
                                                <div className="card-header bg-light-red">
                                                    <div className="d-flex justify-content-between align-items-center">
                                                        <div className="card-title">{type.collectionPointTypeName}</div>
                                                    </div>
                                                </div>
                                                <div className="card-body rounded-0 rounded-bottom border">
                                                    <div className="d-flex justify-content-between">
                                                        <div className="card-text">
                                                            <span
                                                                style={{ color: 'blue', cursor: 'pointer' }}
                                                                onClick={() => type.collectionPointTypeId === 1 || type.collectionPointTypeId === 4  ? handleTypeBasedCollectionPointCount(type.collectionPointTypeId) : handleHotspotCollectionPointCount(type.collectionPointTypeId, type.collectionPointTypeName)}
                                                            >
                                                                {type.totalCount}
                                                            </span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                            <div class="row mb-2 ms-2">
                                <p class="text-black text-start">
                                    <b>Note:-</b>&nbsp;Cleared - <i className="fas fa-map-marker-alt text-success" style={{ fontSize: '32px' }}></i>
                                    &nbsp;Not Cleared - <i className="fas fa-map-marker-alt" style={{ color: '#FF7659', fontSize: '32px' }}></i>
                                    &nbsp;Pending - <i className="fas fa-map-marker-alt" style={{ color: '#6D61FF', fontSize: '32px' }} ></i>
                                    &nbsp;Hotspot - <i className="fas fa-map-marker-alt text-warning" style={{ fontSize: '32px' }} ></i>
                                    &nbsp;GVP - <i className="fas fa-map-marker-alt" style={{ color: '#0cd925', fontSize: '32px' }}></i>
                                    &nbsp;Litter Bin - <i className="fas fa-map-marker-alt" style={{ color: '#61d3ff', fontSize: '32px' }} ></i>
                                    &nbsp;Sweeping Point - <i className="fas fa-map-marker-alt " style={{ fontSize: '32px', color: '#b30d0d' }} ></i>
                                    &nbsp;Others - <i className="fas fa-map-marker-alt " style={{ fontSize: '32px', color: 'blue' }} ></i>
                                </p>
                            </div>
                            {/*--- map-- */}
                            <div className="col-md-12">
                                <div className="form-group">
                                    <div className="card-header card-bg">
                                        <h4 className="card-title mt-0 text-center fs16">Map</h4>
                                    </div>
                                    <div className="p-20">
                                        <MapContainer
                                            center={[position.lat, position.lng]}
                                            zoom={11}
                                            style={{ height: "400px", width: "100%" }}
                                        >
                                            <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
                                            {/* <GeoJSON data={GHMCBoundariesJSON} style={boundaryStyle} /> */}
                                            {selectedGeoJSON ? (
                                                      <GeoJSONLayer data={selectedGeoJSON} />

                                                // <GeoJSON data={selectedGeoJSON} style={boundaryStyle} />
                                            ) : (
                                                <div>Loading new boundaries...</div>
                                            )}
                                            {collectionPoints && collectionPoints.map((point, index) => {
                                                const icon = getIconForCollectionPoint(point.collectionPointType);
                                                return (
                                                    <Marker
                                                        name={point.collectionPointLatitude}
                                                        key={index}
                                                        position={[point.collectionPointLatitude, point.collectionPointLongitude]}
                                                        icon={icon}
                                                    >
                                                        <Popup>
                                                            <strong>{point.collectionPointName}</strong><br />
                                                            Latitude: {point.collectionPointLatitude}, Longitude: {point.collectionPointLongitude}<br />
                                                            Vehicle: {point.vehicleNumber}<br />
                                                            Image: {point.beforeImageUrl}
                                                        </Popup>
                                                    </Marker>
                                                );
                                            })}
                                        </MapContainer>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default GVPClearanceMapView;


const getCurrentDateTime = () => {
    const now = new Date();
    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, "0");
    const day = String(now.getDate()).padStart(2, "0");
    // const hour = String(now.getHours()).padStart(2, "0");
    // const minute = String(now.getMinutes()).padStart(2, "0");
    return `${year}-${month}-${day}`;
};

const inputStyle = {
    border: "1px solid #E2E2E2",
    padding: "15px",
    borderRadius: "0px",
};
const shiftTimings = () => {
    const morning = '05:00 - 14:00';
    const afternoon = '14:30 - 21:00';
    const night = '21:00 - 05:00';
    if (shiftTimings >= morning && shiftTimings <= afternoon) {
        return morning
    } else
        if (shiftTimings >= afternoon && shiftTimings >= night) {
            return afternoon
        } else
            if (shiftTimings >= night && shiftTimings <= morning
            ) {
                return night
            }

}